import React, { Component } from 'react';

class ButtonNexcareDefault extends Component {
    render() {
        return (
            <button
                type={this.props.type}
                id={this.props.id}
                onClick={this.props.onClick}
                className={`${this.props.className} bg-nexcaredefault rounded-md border border-nexcaredefault text-white focus:outline-none font-medium px-6 py-2`}
                style={this.props.style}
            >
                {this.props.children}
            </button>
        );
    }
}

export default ButtonNexcareDefault;